// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"6bb98851","828":"e6a462f6"}[chunkId] + ".chunk.js";
};